module.exports = __webpack_public_path__ + "img/Prep.d1d51fe6.jpeg";